export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/pages/free-trial', '/accounts/free_trial', '#free-trial-registration', {
      params: ['skus']
    });
  });
}
